'use strict';

exports.__esModule = true;
exports['default'] = childContextTypes;

var _validators = require('../../utils/validators');

function childContextTypes(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'childContextTypes');

    // eslint-disable-next-line
    target.childContextTypes = props;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/context/childContextTypes.js
// module id = 562
// module chunks = 1